import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import Filter from "../components/datatable/Filter";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";

const DISABLED_FILTER_OPTIONS = {
    active: {
        name: "Active",
        value: 'active'
    },
    disabled: {
        name: "Archived",
        value: 'archived'
    }
}

const UsersDataTable = () => {
    const dataTableRef = useRef(null);
    const [search, setSearch] = useState("");

    const [disabledFilter, setDisabledFilter] = useState(DISABLED_FILTER_OPTIONS.active.value);

    const renderRowButton = (user) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!user.can && user.can.view === true && (
                        <a className="text-primary cursor-pointer" href={route('user.show', {user: user.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card title={"Users"} classes={"mh-100 border-0"}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                    <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                        <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                            <Filter
                                label="Status:"
                                value={disabledFilter}
                                options={Object.values(DISABLED_FILTER_OPTIONS)}
                                name="filter_disabled"
                                onChange={(value) => setDisabledFilter(value)}
                                classes=""
                            />
                            {can('create', 'user') && (
                                    <Button
                                        href={route('user.create').toString()}
                                        label="Create User"
                                        icon="far fa-plus-circle"
                                        classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                    />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-xl-4 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                        <SearchInput
                                    value={search}
                                    classes={""}
                                    placeholder={"Search..."}
                                    onChange={(value) => setSearch(value)}
                                />
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.user.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="users" />}
                                fieldsToExclude={disabledFilter === DISABLED_FILTER_OPTIONS.disabled.value ? [
                                    'id',
                                    'created_at',
                                    'can',
                                ] : [
                                    'id',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    user_name:      "Name",
                                    email:          "Email Address",
                                    last_logged_in: "Last Login"
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'user_name'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm: search,
                                    filterDisabled: disabledFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default UsersDataTable;

const target = document.getElementById('users-datatable');
if (target) {
    ReactDOM.render(<UsersDataTable />, target);
}
